// extracted by mini-css-extract-plugin
export default {"card":"GameCard_card__5OS4x","badge":"GameCard_badge__v9X8Y","title":"GameCard_title__y3oyB","desc":"GameCard_desc__hQNC0","btn":"GameCard_btn__mqZWf"};